// @flow

import { connect } from 'react-redux';
import MoreInfo from './moreinfo';
import {
  updateSearchParam,
  resetSearchPrams,
  addCurrentSearchParamsToHistory,
} from '../../../services/search';

export type Props = {
  children: Element,
  search: any,
  updateSearchParam: (name: string, value: string) => void,
  resetSearchPrams: () => void,
  addCurrentSearchParamsToHistory: () => void,
};

const mapState = ({ search }) => ({
  hasPossibleMatches: (
    search.searchDetails.workMatches &&
    search.searchDetails.workMatches.length &&
    true
  ) || false,
  hasAlternativeTitles: (
    search.searchDetails.titles &&
    search.searchDetails.titles
      .filter(v => v.entityTitle.startsWith('Alternative Title')).length &&
    true
  ) || false,
});

const mapDispatch = {
  updateSearchParam,
  resetSearchPrams,
  addCurrentSearchParamsToHistory,
};

export default connect(
  mapState,
  mapDispatch,
)(MoreInfo);
